import { faExclamationTriangle, faPersonBooth, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Alert, Button, Form, FormGroup, Modal, Row, Toast } from "react-bootstrap";
import { getUserIDsWithParent, getUserList } from "../store/api/FlowAPI";
import BihamtaTable from "../../Components/BihamtaTable";
import { updateUsersParent } from "../store/api/FlowAPI";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import { CheckLg } from "react-bootstrap-icons";

export default function ModalUserRelations(props) {
    const { popData, setPopData } = props;
    const [userList, setUserList] = useState();
    const selectedUsers = useRef([]);
    const inputParent = useRef();
    const tblUsers = useRef();
    const [pending, setPending] = useState(false);
    const [submitError, setSubmitError] = useState();
    const tableCols = [
        { colTitle: "انتخاب", colName: "select", colType: "boolean", editable: true, onChange: selectRow, style: { width: "50px" } },
        { colTitle: "نام کاربر", colName: "Name" },
        { colTitle: "", colName: "ID", style: { display: "none" }, headerStyle: { display: "none" } }
    ]
    function close() {
        setPopData({ show: false });
        selectedUsers.current = [];
        setSubmitError(null);
    }
    function selectRow(row) {
        const userID = Number(row.ID);
        if (row.e.target.checked) {
            if (!selectedUsers.current.includes(userID)) {
                selectedUsers.current.push(userID);
            }
        }
        else {
            selectedUsers.current = selectedUsers.current.filter(r => r !== userID);
        }
    }
    function update() {
        if (pending) {
            return;
        }
        if (inputParent.current.value === "") {
            setSubmitError("کاربر اصلی انتخاب نشده است.");
            return;
        }
        if (selectedUsers.current.length < 1) {
            setSubmitError("دست کم یک کاربر مرتبط باید انتخاب شود.");
            return;
        }
        setSubmitError(null);
        setPending(false);
        const onUpdate = (res) => {
            if (res.Error) {
                setSubmitError(res.Error);
                setPending(false);
            }
            else if (res !== "PENDING") {
                setPending(false);
                setSubmitError("ثبت با موفقیت انجام شد.");
                selectedUsers.current = [];
            }
        }
        updateUsersParent(inputParent.current.value, selectedUsers.current, onUpdate);
    }
    function onParentSelect(e) {
        const parentID = e.target.value;
        const table = tblUsers.current;

        const onGet = (res) => {
            table.style.display = "none";
            table.querySelectorAll("input[type='checkbox']").forEach(c => c.checked = false);
            selectedUsers.current = [];
            if (res.Data?.length > 0) {
                for (let i = 1; i < table.rows.length; i++) {
                    const row = table.rows[i];
                    const id = Array.from(row.cells).find(c => c.getAttribute("colname") === "ID")?.innerText;
                    const exists = res.Data.some(r => Number(r) === Number(id));
                    if (exists) {
                        selectedUsers.current.push(Number(id));
                        const checkbox = row.querySelector("input[type='checkbox']");
                        if (checkbox) {
                            checkbox.checked = true;
                        }
                    }
                }
            }
            table.style.display = "table";
        }
        getUserIDsWithParent(parentID, onGet);
    }
    useEffect(() => {
        if (popData?.show) {
            getUserList("", setUserList);
        }
    }, [popData?.show])
    return (
        <Modal show={popData?.show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span><FontAwesomeIcon icon={faPersonBooth} size="lg" />&nbsp;مدیریت ارتباط کاربران</span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: "5px" }}>
                {submitError &&
                    <Alert variant="info">
                        <FontAwesomeIcon icon={faExclamationTriangle} size="lg" />&nbsp;{submitError}
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                    </Alert>}
                <FormGroup>
                    <label>کاربر اصلی:</label>
                    {Array.isArray(userList) ?
                        <select ref={inputParent} className="form-control" onChange={onParentSelect}>
                            {userList.map((user, i) => <option value={user.ID} key={i}>{user.Name}</option>)}
                        </select> :
                        <div className="form-control"></div>
                    }
                </FormGroup>
                <Row className="rowBorder mt-3" style={{ padding: "8px" }}>
                    <div className="rowTitle">کاربران مرتبط</div>
                    <BihamtaTable tableRef={tblUsers} columns={tableCols} dataList={{ Data: userList }} maxHeight={500} className="mt-0 mb-0"/>
                </Row>
                <Button variant="success mt-1" className="group-Btn-large" onClick={update}><CheckLg size={18} />&nbsp;ثبت تغییرات</Button>
            </Modal.Body>
        </Modal>
    )
}